<template>
  <div>
    <BOverlay
      :show="loading"
      no-center
      :opacity="0.3"
      variant="light"
      rounded="sm"
    >
      <template #overlay>
        <loading-spinner />
      </template>

      <BRow>
        <BCol cols="12">
          <BCard>
            <BRow>
              <BCol
                v-for="(user, i) in users"
                :key="user.id"
                cols="12"
              >
                <div class="user-card">
                  <router-link :to="{name: 'users.show', params: {id: user.uuid}}">
                    <div class="profile">
                      <div class="image">
                        <b-avatar
                          size="40"
                          :src="user.image"
                          variant="light-primary"
                          class="badge-minimal"
                          badge
                          :badge-variant="user.status ? 'success' : 'danger'"
                        >
                          <feather-icon
                              v-if="!user.image"
                              icon="UserIcon"
                              size="22"
                          />
                        </b-avatar>
                      </div>
                      <div class="username-country">
                        <p class="username">
                          {{ user.user_name }}
                        </p>
                        <p class="country">
                          {{ $t(user.country) }}
                        </p>
                      </div>
                    </div>
                  </router-link>
                  <div
                    v-if="getLabelText(user)"
                    class="label"
                  >
                    <span
                      class="indicator"
                      :style="{ backgroundColor: getLabelColor(user) }"
                    />
                    {{ getLabelText(user) }}
                  </div>
                  <div class="actions">
                    <div class="chat">
                      <b-img
                        :src="iconChat"
                        height="20"
                        width="20"
                        class="mr-1"
                        @click="chat(user, i)"
                      />
                    </div>
                    <div
                      v-if="user.status"
                      class="phone"
                    >
                      <b-img
                        :src="iconPhoneWhite"
                        height="20"
                        width="20"
                        class="mr-1"
                        @click="call(user, i)"
                      />
                    </div>
                    <div
                      v-if="user.camera_on && userCanStartVideoCall && user.status"
                      class="video-call"
                    >
                      <b-img
                        :src="iconVideoCall"
                        height="30"
                        width="30"
                        @click="videoCall(user, i)"
                      />
                    </div>
                  </div>
                  <div
                    v-if="false"
                    class="description"
                  >
                    <div style="z-index: 3">
                      <div class="d-flex flex-column justify-content-between">
                        <div
                          v-if="user.country"
                          class="country"
                        >
                          <b-img-lazy
                            :src="require(`@/assets/images/flags/${user.country.toLowerCase()}.svg`)"
                            fluid
                            rounded="circle"
                            width="20"
                          />
                          {{ $t(user.country) }}
                        </div>
                        <div class="name">
                          <status-indicator :user="user" />
                          {{ user.user_name }}
                          <span v-if="user.profile.year">
                            , {{ new Date().getFullYear() - user.profile.year }}
                          </span>
                        </div>
                      </div>
                      <div class="shortcuts">
                        <div class="chat">
                          <b-img
                            :src="iconChat"
                            height="20"
                            width="20"
                            @click="chat(user, i)"
                          />
                        </div>
                        <div class="phone">
                          <b-img
                            :src="iconPhoneWhite"
                            height="20"
                            width="20"
                            @click="call(user, i)"
                          />
                        </div>
                        <div
                          v-if="user.profile.cameraOn"
                          class="video-call"
                        >
                          <b-img
                            :src="iconVideoCall"
                            height="20"
                            width="20"
                            @click="videoCall(user, i)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </BCol>
              <BCol
                v-if="!loading && users.length < 1"
                cols="12"
              >
                <h3>
                  {{ $t('No users available') }}
                </h3>
              </BCol>
            </BRow>
          </BCard>
        </BCol>
      </BRow>
    </BOverlay>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import { localeChanged, localize } from 'vee-validate'
import { throwDefaultError } from '@/helpers/helpers'
import {
  BAvatar,
  BCard, BCol, BImg, BImgLazy, BOverlay, BRow,
} from 'bootstrap-vue'
import StatusIndicator from '@/components/StatusIndicator.vue'

const iconChat = require('@/assets/images/icons/chat-4.svg')
const iconHeartWhite = require('@/assets/images/icons/heart-white.svg')
const iconHeartEmpty = require('@/assets/images/icons/heart-empty.svg')
const iconPhoneWhite = require('@/assets/images/icons/call2.svg')
const iconVideoCall = require('@/assets/images/icons/video-call3.svg')

export default {
  name: 'ForYouComponent',
  components: {
    BAvatar,
    StatusIndicator,
    BImg,
    BImgLazy,
    BCard,
    BCol,
    BOverlay,
    BRow,
  },
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      callSource: 'call-task-list',
      iconChat,
      iconHeartWhite,
      iconHeartEmpty,
      iconPhoneWhite,
      iconVideoCall,
      labels: {
        // 0: { text: this.$t('Default'), color: '#050505' },
        1: { text: this.$t('New Payer'), color: '#9900FF' },
        2: { text: this.$t('New Register'), color: '#00D07D' },
        3: { text: this.$t('User'), color: '#0e2ed1' },
        4: { text: this.$t('Payer'), color: '#FF00A1' },
        5: { text: this.$t('Subscriber'), color: '#93010d' },
      },
      loading: false,
      users: [],
    }
  },
  computed: {
    userCanStartVideoCall() {
      return this.$store.getters['auth/userCanStartVideoCall']
    },
  },
  created() {
    useJwt.bonusCampaignCheck()
      .then(response => {
        if (response.data.body) {
          this.getUsers()
        }
      })
  },
  methods: {
    call(user, i) {
      // eslint-disable-next-line no-underscore-dangle
      const _user = {
        ...user,
        profile: {
          image: user.image,
        },
        id: user.uuid,
        userName: user.user_name,
      }

      if (this.mobile) {
        if (window.webkit) {
          if (window.webkit.messageHandlers && window.webkit.messageHandlers.iosListener) {
            // eslint-disable-next-line radix
            window.webkit.messageHandlers.iosListener.postMessage({
              key: 'call-user',
              user: _user,
              order: parseInt(i),
              callSource: 'call-task-list',
            })
          }
        }
        if (window.AndroidApp) {
          // eslint-disable-next-line radix
          window.AndroidApp.sendData(JSON.stringify({
            key: 'call-user',
            user: _user,
            order: parseInt(i),
            title: this.$t('Call Task List'),
            callSource: 'call-task-list',
          }))
        }
      } else {
        this.$store.dispatch('app/setModalCallType', 'audio')
        this.$store.dispatch('app/setCallDetails', {
          callSource: this.callSource,
          userOrder: i,
        })
        this.$store.dispatch('app/setModalCall', false)
        setTimeout(() => {
          this.$store.dispatch('app/setModalCallUser', _user)
          this.$store.dispatch('app/setModalCall', true)
        }, 33)
      }
    },
    chat(user, i) {
      // eslint-disable-next-line no-underscore-dangle
      const _user = {
        ...user,
        profile: {
          image: user.image,
        },
        id: user.uuid,
        userName: user.user_name,
      }

      if (this.mobile) {
        if (window.webkit) {
          if (window.webkit.messageHandlers && window.webkit.messageHandlers.iosListener) {
            // eslint-disable-next-line radix
            window.webkit.messageHandlers.iosListener.postMessage({
              key: 'chat-user',
              user: _user,
              order: parseInt(i),
              callSource: 'call-task-list',
            })
          }
        }
        if (window.AndroidApp) {
          // eslint-disable-next-line radix
          window.AndroidApp.sendData(JSON.stringify({
            key: 'chat-user',
            user: _user,
            order: parseInt(i),
            title: this.$t('Call Task List'),
            callSource: 'call-task-list',
          }))
        }
      } else {
        this.$router.push({
          name: 'chat',
          params: {
            userId: user.uuid,
          },
        })
      }
    },
    videoCall(user, i) {
      // eslint-disable-next-line no-underscore-dangle
      const _user = {
        ...user,
        profile: {
          image: user.image,
        },
        id: user.uuid,
        userName: user.user_name,
      }

      if (this.mobile) {
        if (window.webkit) {
          if (window.webkit.messageHandlers && window.webkit.messageHandlers.iosListener) {
            // eslint-disable-next-line radix
            window.webkit.messageHandlers.iosListener.postMessage({
              key: 'video-call-user',
              user: _user,
              order: parseInt(i),
              callSource: 'call-task-list',
            })
          }
        }
        if (window.AndroidApp) {
          // eslint-disable-next-line radix
          window.AndroidApp.sendData(JSON.stringify({
            key: 'video-call-user',
            user: _user,
            order: parseInt(i),
            title: this.$t('Call Task List'),
            callSource: 'call-task-list',
          }))
        }
      } else {
        this.$store.dispatch('app/setModalCallType', 'video')
        this.$store.dispatch('app/setCallDetails', {
          callSource: this.callSource,
          userOrder: i,
        })
        this.$store.dispatch('app/setModalCall', false)
        setTimeout(() => {
          this.$store.dispatch('app/setModalCallUser', _user)
          this.$store.dispatch('app/setModalCall', true)
        }, 33)
      }
    },
    getUsers() {
      this.loading = true
      useJwt.bonusCampaignUserList(0, 30)
        .then(response => {
          this.users = response.data.body
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    isAvailable(user) {
      return user && user.profile.onlineStatus === 'online' && user.profile.busyInCall
    },
    getLabelText(user) {
      if (!user || typeof user.userLabel === 'undefined' || typeof this.labels[user.userLabel] === 'undefined') {
        return null
      }

      return this.labels[user.userLabel].text
    },
    getLabelColor(user) {
      if (!user || typeof user.userLabel === 'undefined' || typeof this.labels[user.userLabel] === 'undefined') {
        return '#050505'
      }

      return this.labels[user.userLabel].color
    },
    updateLocale(locale) {
      this.$i18n.locale = locale
      localize(locale)
      localeChanged()
      localStorage.setItem('locale', locale)

      if (locale === 'ar') {
        localStorage.setItem('isRTL', 'on')
      }
      this.$store.commit('appConfig/TOGGLE_RTL', locale === 'ar')

      this.updateLocaleFromServer(locale)
    },
    updateLocaleFromServer(lang) {
      if (lang) {
        useJwt.updateLanguage(lang)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.user-card {
  width: 100%;
  max-width: 440px;
  padding: 12px;
  background-color: #F4F7FB !important;
  margin-bottom: 10px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  color: #000000 !important;

  .profile {
    display: flex;
    align-items: center;
    gap: 6px;
    .image {
      position: relative;
      overflow: hidden;
      width: 42px;
      height: 42px;
      .user-image {
        border-radius: 12px;
      }
    }
    .username-country {
      display: flex;
      flex-direction: column;
      gap: 5px;
      justify-content: center;
      .username {
        font-size: 13px;
        margin-bottom: 0;
        line-height: 1;
      }
      .country {
        font-size: 12px;
        font-weight: 300;
        margin-bottom: 0;
        line-height: 1;
      }
    }
  }
  .label {
    display: flex;
    align-items: center;
    font-size: 12px;

    .indicator {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #0bb708;
      margin-right: 3px;
    }
  }

  .actions {
    display: flex;
    align-items: center;
    gap: 2px;
    div {
      cursor: pointer;
    }
  }
}
</style>
